import React from "react";
import tw from "tailwind-styled-components";
import { MenuContainer } from "../Styles/AccountMenuStyles";
import MyPayments from "./MyPayments";
import MyActivity from "./MyActivity";
import OtherMenu from "./OtherMenu";
import { useNavigate } from "react-router-dom";

const AccountMenu = ({ onLogout, displayData }) => {
  const navigate = useNavigate();
  return (
    <MenuContainer>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-6 md:max-w-6xl md:mx-auto md:p-6">
        <MyPayments />
        <MyActivity />
        <OtherMenu onLogout={onLogout} displayData={displayData} />
      </div>
    </MenuContainer>
  );
};

export default AccountMenu;